"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookImpl = void 0;
class WorkbookImpl {
}
exports.WorkbookImpl = WorkbookImpl;
//# sourceMappingURL=WorkbookImpl.js.map